import React, { useEffect, createElement } from 'react';
export const BookingPage = () => {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    // Load Calendly CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(link);
    return () => {
      // Clean up the script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      // Clean up the link when component unmounts
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);
  return <div className="min-h-screen bg-purple-50 pt-24 pb-12" data-id="element-44">
      <div className="container mx-auto px-4 md:px-6" data-id="element-45">
        <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8" data-id="element-46">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-47">
            Speak with a Senior PM
          </h1>
          <p className="text-text-secondary text-center mb-8" data-id="element-48">
            Schedule a 30-minute consultation with one of our experienced
            product managers.
          </p>
          <div className="calendly-inline-widget" data-url="https://calendly.com/zerototendigital/exploration-feature-design" style={{
          minWidth: '320px',
          height: '700px'
        }} data-id="element-49" />
        </div>
      </div>
    </div>;
};